import axios from "axios";
import { getToken } from "./util";
import {
  showUserHistoryEndPoint,
  showLeaderBoardEndPoint,
  showOtherPerformersOnLeaderBoard,
  gameLaunchEndPoint,
} from "./apiEndPoints";

interface ApiResponse<T> {
  data: T;
}

const showUserHistory = async (
  newStart: number
): Promise<ApiResponse<any> | undefined> => {
  const userToken = getToken();
  try {
    return axios.get<ApiResponse<any>>(
      `${showUserHistoryEndPoint}?start=${newStart}&count=5`,
      {
        headers: {
          "x-auth-token": userToken,
        },
      }
    );
  } catch (error) {
    console.error("API request failed:", error);
  }
};

const showUserPerformance = async (): Promise<ApiResponse<any> | undefined> => {
  const userToken = getToken();
  try {
    const response = await axios.get<ApiResponse<any>>(
      showLeaderBoardEndPoint,
      {
        headers: {
          "x-auth-token": userToken,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("API request failed:", error);
  }
};

const showOtherUsersPerformance = async (
  newStart: number
): Promise<ApiResponse<any> | undefined> => {
  const userToken = getToken();
  try {
    const response = await axios.get<ApiResponse<any>>(
      `${showOtherPerformersOnLeaderBoard}?start=${newStart}&count=10`,
      {
        headers: {
          "x-auth-token": userToken,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("API request failed:", error);
  }
};

interface GameLaunchParams {
  id: string | number;
  currency: string;
  customToken?: string;
}

const gameLaunchUrl = async ({
  id,
  currency,
  customToken,
}: GameLaunchParams) => {
  try {
    const userToken = customToken ?? getToken();
    const requestData = {
      gameId: id.toString(),
      operatorCode: "NGP",
      authToken: userToken,
      currencyCode: currency || "USD",
    };
    const response = await axios.post(gameLaunchEndPoint, requestData);
    return response.data;
  } catch (error) {
    console.error("API request failed:", error);
  }
};

export {
  showUserHistory,
  showUserPerformance,
  showOtherUsersPerformance,
  gameLaunchUrl,
};
